import axios from 'axios';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';
import { useEffect } from 'react';





const NEET_SubscribersModal = forwardRef((props, ref) => {
    const [modalBox, setModalBox] = useState(false);
    let initialData = {
        ExamType: 'Select Exam Type',
        Subject: 'Select Subject',
        SubjectID: 0,
        TestCount: 5,
        EmailId: ''
    }


    const [examBodyData, setExamBodyData] = useState(initialData);
    const [subjects, setSubjects] = useState([]);


    console.log(examBodyData);
    useImperativeHandle(ref, () => ({
        openModal(item = {}) {
            // if (item.Sn > 0) {
            //     setExamBodyData(item)
            // }
            setModalBox(true);

        }
    }));
    useEffect(() => {
        axios.get(BACKEND_SERVER_URL + '/neet/subjects/').then((res) => {
            let subjects = res.data.subjects;
            setSubjects(subjects);
        }).catch((error) => {
            console.log(error)
            toast.error(error.response.data.message)
        })

    }, [])

    const hanldeSaveExamBody = async () => {
        try {
            if (examBodyData.SubjectID == 0) {
                toast.error("Please Select a Subject")
                return;
            } else if (!examBodyData.TestCount) {
                toast.error("Please Enter Test Count")
                return;
            } else if (!examBodyData.EmailId) {
                toast.error("Please Enter Email")
                return;
            }
            const response = axios.post(BACKEND_SERVER_URL + `${!examBodyData.Sn ? '/neet/createEnrollment' : `/neet/updateSubject`}`, examBodyData);
            setModalBox(false);
            toast.success(response.data.message);
            props.setSubjectLoading(!props.loadSubjects);

        } catch (error) {
            console.log(error)
            toast.error(error?.response?.data?.message)
        } finally {
            props.setSubjectLoading(!props.loadSubjects);
            setExamBodyData(initialData)
            setExamBodyData(initialData);
        }

    }

    return (
        <>
            <Modal onHide={setModalBox} show={modalBox} size="md" backdrop="static"
                keyboard={false} >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel"> {examBodyData.Sn ? "Update Class" : "Create Subject"}</h5>
                        <button type="button" className="btn-close" onClick={() => setModalBox(false)}></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3">
                            <label htmlFor="sessioncount" className="form-label text-primary">Subject<span className="required">*</span></label>
                            <Select
                                value={{ value: examBodyData.Subject, label: examBodyData.Subject }}
                                onChange={(selectedOption) => setExamBodyData({ ...examBodyData, Subject: selectedOption.value.Subject, SubjectID: selectedOption.value.Sn })}
                                options={subjects?.map((course) => ({ value: course, label: course.Subject }))}
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        width: '100%',
                                        backgroundColor: 'transparent', // Adjust as needed
                                        borderColor: '#17a2b8', // Adjust as needed

                                    }),
                                }}
                            />
                        </div>

                        <div className="mb-3">
                            <label htmlFor="TestCount" className="form-label text-primary">Test Count<span className="required">*</span></label>
                            <input autoFocus className='form-control' type="number" name="" id="TestCount" value={examBodyData.TestCount} onChange={(e) => setExamBodyData({ ...examBodyData, TestCount: e.target.value })} />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="email" className="form-label text-primary">Email ID<span className="required">*</span></label>
                            <input autoFocus className='form-control' type="email" name="" id="email" value={examBodyData.EmailId} onChange={(e) => setExamBodyData({ ...examBodyData, EmailId: e.target.value })} />
                        </div>



                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger btn-xs" onClick={() => setModalBox(false)}>Close</button>
                        <button type="button" className="btn btn-primary btn-xs " onClick={hanldeSaveExamBody}>{examBodyData.Sn ? "Update" : "Create "}</button>
                    </div>
                </div>
            </Modal>

        </>
    )
})
export default NEET_SubscribersModal;